import React from 'react';
import { SubHeading } from '../../components';

import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      <SubHeading title="Uncover the riches of cultural cuisine"/>
      <h1 className='app__header-h1'>Savor the essence of delicious flavor.</h1>
      <p className='p__opensans' style={{ margin: '2rem 0'}}>A feast for the senses and a celebration of taste, prepared with the freshest ingredients. Serving delicious chinese cuisine since 1998</p>
      <button type='button' className='custom__button'> Explore Menu</button>
    </div>

    <div className='app__wrapper_img'>
      ,<img src={images.welcome} alt="" />
    </div>
  </div>
);

export default Header;
